// extracted by mini-css-extract-plugin
export var banner = "banner-module--banner--1230e";
export var bannerH2 = "banner-module--banner-h2--f9504";